
const GallerySection = ({ children, aligment } : { children : JSX.Element[], aligment? : string}) => {
    return (
        <div className={`gallery-section ${aligment === "center"} aligment-center`}>
            {children}
        </div>
    )
}

export default GallerySection;